<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import RankingSetForm from "../../../components/performance/rankingset/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": RankingSetForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('Setuprankingset.createnewrankingset'),
      pageTitleValue: "",
      formData: {
        rankingsetcode: null,
        rankingsetdesc: null,
        isdisable: false,
        remarks: null,
        rankingsetdetail: [],

        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
      },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {url: "/rankingset/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "rankingsetlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
           console.log("err", err);
        });
    },

  

    cancelHandler() {
      this.$router.push({ name: "rankingsetlist" });
    },
  },
};
</script>